import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import InvoiceForm from '../../../components/forms/InvoiceForm';
import { useInvoiceApi } from '../../../hooks/useInvoiceApi';
import { useLocation, useNavigate } from 'react-router-dom';
import { InvoiceDTO } from '../../../services/apiClient';

const InvoiceCreate: React.FC = () => {
  const { create, createAndFinalize, isLoading } = useInvoiceApi();
  const navigate = useNavigate();
  const location = useLocation();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const prefilledInvoice = (location.state as any)?.prefilledInvoice as InvoiceDTO | undefined;

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Invoices', href: '/admin/invoices' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: InvoiceDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate(-1);
    } catch (error) {
      console.error('Error creating Invoice:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  const handleSubmitFinalized = async (data: InvoiceDTO) => {
    try {
      setIsSubmitting(true);
      await createAndFinalize(data);
      navigate(-1);
    } catch (error) {
      console.error('Error creating and finalizing Invoice:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/invoices"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Finance.Invoice.Edit'
    >
        <InvoiceForm
          initialValues={(prefilledInvoice ?? ({} as InvoiceDTO))}
          onSubmit={handleSubmit}
          onSubmitFinalized={handleSubmitFinalized}
          onCancel={() => navigate(-1)}
          isLoading={isSubmitting}
          shouldFinalize={true}
        />
    </AdminLayout>
  );
};

export default InvoiceCreate;